import { GraduationCap, BookOpen, Github, Users, Calendar } from 'lucide-react';

// Inline Discord SVG component (uses currentColor so it inherits text color)
const DiscordSvgIcon = ({ className }) => (
    <svg
        width="21"
        height="17"
        viewBox="0 0 21 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M6.92475 10.088C5.88475 10.088 5.03675 9.143 5.03675 7.987C5.03675 6.831 5.86375 5.885 6.92575 5.885C7.97575 5.885 8.83575 6.83 8.81475 7.987C8.81475 9.143 7.97575 10.088 6.92475 10.088ZM13.8987 10.087C12.8587 10.087 12.0087 9.142 12.0087 7.986C12.0087 6.83 12.8377 5.884 13.8987 5.884C14.9487 5.884 15.8087 6.829 15.7887 7.986C15.7887 9.142 14.9597 10.087 13.8987 10.087ZM8.52975 0.563L8.22175 0L7.58775 0.106C6.15105 0.34612 4.75275 0.776573 3.42975 1.386L3.20175 1.491L3.05975 1.701C0.446748 5.554 -0.270253 9.349 0.0847473 13.076L0.123747 13.483L0.453747 13.723C1.99085 14.851 3.70775 15.7108 5.53175 16.266L6.32175 16.508L7.43475 13.792C9.34475 14.264 11.4647 14.264 13.3737 13.792L14.4807 16.509L15.2707 16.267C17.0963 15.7132 18.8142 14.8526 20.3507 13.722L20.6777 13.484L20.7177 13.082C21.1537 8.762 20.0207 4.999 17.7597 1.698L17.6177 1.49L17.3897 1.386C16.0672 0.779106 14.6705 0.34875 13.2357 0.106L12.6177 0.00300002L12.3037 0.545C12.2157 0.695 12.1267 0.865 12.0407 1.038C10.9559 0.926802 9.86257 0.926802 8.77775 1.038C8.69275 0.868 8.60775 0.704 8.52975 0.563ZM5.11975 12.852C5.31675 12.966 5.52475 13.078 5.72975 13.18L5.28075 14.276C4.06625 13.8335 2.91403 13.2359 1.85275 12.498C1.62775 9.36 2.26575 6.193 4.41675 2.928C5.32462 2.52853 6.27085 2.22262 7.24075 2.015C7.30075 2.14 7.35675 2.263 7.40275 2.371L7.67575 3.014L8.36775 2.913C9.72383 2.71422 11.1017 2.71422 12.4577 2.913L13.1477 3.013L13.4197 2.371C13.4667 2.259 13.5217 2.137 13.5797 2.015C14.5567 2.225 15.5027 2.535 16.4077 2.93C18.2827 5.75 19.2287 8.896 18.9537 12.497C17.8919 13.2354 16.739 13.8334 15.5237 14.276L15.0787 13.181C15.2847 13.079 15.4927 12.967 15.6917 12.852C16.1817 12.57 16.7087 12.218 17.0447 11.882L15.7647 10.602C15.6017 10.766 15.2417 11.022 14.7877 11.284C14.3437 11.54 13.9027 11.747 13.6207 11.84C11.6177 12.503 9.19275 12.503 7.18875 11.84C6.90775 11.747 6.46675 11.54 6.02275 11.284C5.56875 11.023 5.20875 10.766 5.04475 10.602L3.76475 11.882C4.10175 12.218 4.62975 12.57 5.11975 12.852Z"
            fill="currentColor"
        />
    </svg>
);
import Header from '../../components/dashboard-layout/Header';
import Hero from '../../components/sections/Hero';
import Footer from '../../components/dashboard-layout/Footer';
import CoverPageCard from '../../components/cards/CoverPageCard';
import { useEffect } from 'react';

// Features Section
const Features = () => {
    useEffect(() => {
        document.title = 'Learning Portal | Zindua LMS';
    }, []);

    return (
        <section className="py-16">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 lg:auto-rows-fr gap-6 mb-8">
                    <div className="lg:col-span-2 lg:row-span-1">
                        <CoverPageCard
                            icon={GraduationCap}
                            title="Explore our Programs"
                            description="Discover our Software and Data core programs as well as our NEW specialization programs for advanced developers"
                            linkText="Go to Website"
                            linkHref="https://zinduaschool.com/#programs"
                        />
                    </div>

                    <div className="lg:row-span-2 lg:col-span-1">
                        <CoverPageCard
                            icon={BookOpen}
                            title="Free Courses"
                            description="We offer free foundational courses to get your started in your Software, Data, or even AI career pathway"
                            linkText="Join Free Courses"
                            linkHref="/available-courses"
                        />
                    </div>

                    <div className="lg:row-span-1 lg:col-span-1">
                        <CoverPageCard
                            icon={Github}
                            title="Github Community"
                            description="Click here to explore our open-source Git repositories"
                            linkText="Learn More"
                            linkHref="https://github.com/zinduaschool"
                        />
                    </div>

                    <div className="lg:row-span-1 lg:col-span-1">
                        <CoverPageCard
                            icon={Users}
                            title="Masterclasses"
                            description="One to three-Day technical workshops on niche tech skills"
                            linkText="Discover Masterclasses"
                            linkHref="https://zinduaschool.com/masterclasses"
                        />
                    </div>

                    <div className="lg:row-span-1 lg:col-span-1">
                        <CoverPageCard
                            icon={Calendar}
                            title="Events/Webinars"
                            description="Free events, webinars for techies and aspiring techies alike"
                            linkText="Explore Events"
                            linkHref="https://lu.ma/zinduaschool"
                        />
                    </div>

                    <div className="lg:row-span-1 lg:col-span-1">
                        <CoverPageCard
                            icon={DiscordSvgIcon}
                            title="Discord Community"
                            description="Click here to join discussions on Zindua Discord channels"
                            linkText="Learn More"
                            linkHref="https://discord.gg/mXVPnfEh4t"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

const CoverPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-neutral-50">
            <Header />
            <main className=" max-w-350 mx-auto grow mt-20">
                <Hero />
                <Features />
            </main>
            <Footer />
        </div>
    );
};

export default CoverPage;
